import Copyright from "./Copyright";

export default Copyright;
